const { TextField, Select, MenuItem } = require("@material-ui/core");
const { useState, useEffect } = require("react");

const FromToDatePicker = (props) => {
    return <>
        <div style={{ display: "flex" }}>
            <div>
                <label style={{
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "14px",
                      color: "black",
                      fontWeight: "bold",
                      marginTop: "-5px",
                    }}
                > From Date
                </label>
                <TextField
                    id="date"
                    type="date"
                    value={props.fromDate ? props.fromDate : ""}
                    onChange={(e) => {
                        if (props.onChange) {
                            props.onChange(e.target.value,props.toDate)
                        }
                    }}
                    placeholder="DD-MM-YYYY"
                    style={{
                        width: "90%",
                        marginTop: "-10px",
                        backgroundColor: "white",
                    }}
                />
            </div>
            <div>

                <label
                    style={{
                        fontFamily: "GT-Walsheim-medium",
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "bold",
                        marginTop: "-5px",
                      }}
                >
                     To Date
                </label>
                <TextField
                    id="date"
                    type="date"
                    value={props.toDate ? props.toDate : ""}
                    onChange={(e) => {
                        if (props.onChange) {
                            props.onChange(props.fromDate, e.target.value)
                        }
                    }}
                    format="DD/MM/YYYY"
                    style={{
                        width: "90%",
                        marginTop: "-10px",
                        backgroundColor: "white",
                    }}
                />
            </div>
        </div>
    </>
}

export default FromToDatePicker